import { SpotLabel } from '../../pages/risk-management/risk-management-data';
import './styles.scss';

type CheckToggleLabelsProps = {
  labels: SpotLabel[];
};

export const CheckToggleLabels = ({ labels }: CheckToggleLabelsProps) => {
  if (!labels || labels.length === 0) return <></>;

  const isFreezeSpot = (key: string) => key === 'freezeSpot';

  return (
    <div className="portfolio-management-check-toggle-labels">
      <span className="portfolio-management-check-toggle-first-label">Using:</span>
      {labels?.map(({ label, labelKey }) => {
        if (isFreezeSpot(labelKey)) {
          const [prefix, number] = label.split(': ');
          return (
            <span key={labelKey} className="portfolio-management-check-toggle-dynamic-label">
              <span className="freeze-spot-prefix">{prefix}: </span>
              <span className="freeze-spot-number">{number}</span>
            </span>
          );
        }
        return (
          <span key={labelKey} className="portfolio-management-check-toggle-dynamic-label">
            {label}
          </span>
        );
      })}
    </div>
  );
};
